export const defaultAppLanguage = 'EN';
